import React from "react";
import OfferCard from "./OfferCard";
import useTheme from "../../context/themcontext";

import "./OfferCard.css";

function Offerpage() {
  const { themeMode } = useTheme();
  const isDark = themeMode === "dark" ? true : false;

  const offercardoptions = [
    {
      heading: "UI / UX Design",
      description:
        "We specialize in UI/UX design, creating visually captivating and user-friendly interfaces that enhance the overall digital experience. Our team combines artistic creativity with strategic thinking to craft intuitive designs that engage users, drive conversions, and leave a lasting impression.",
      svg: (
        <svg
          fill={isDark ? "#832ac7" : "#4B0D7B"}
          className=" h-16  "
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 511.996 511.996"
          xmlSpace="preserve"
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <g>
              {" "}
              <g>
                {" "}
                <path d="M244.606,137.494c-26.153,0-47.432,21.278-47.432,47.431c0,26.153,21.278,47.432,47.432,47.432 c26.154,0,47.431-21.278,47.431-47.432C292.036,158.77,270.759,137.494,244.606,137.494z M244.606,214.877 c-16.515,0-29.953-13.437-29.953-29.953c0-16.516,13.437-29.952,29.953-29.952c16.515,0,29.952,13.437,29.952,29.952 C274.557,201.44,261.12,214.877,244.606,214.877z"></path>{" "}
              </g>{" "}
            </g>{" "}
            <g>
              {" "}
              <g>
                {" "}
                <path d="M452.072,123.043c-17.141,0-31.087,13.946-31.087,31.087c0,17.141,13.946,31.087,31.087,31.087 s31.087-13.946,31.087-31.087C483.158,136.989,469.212,123.043,452.072,123.043z M452.072,167.738 c-7.503,0-13.608-6.105-13.608-13.608s6.104-13.608,13.608-13.608s13.608,6.105,13.608,13.608 C465.679,161.634,459.575,167.738,452.072,167.738z"></path>{" "}
              </g>{" "}
            </g>{" "}
            <g>
              {" "}
              <g>
                {" "}
                <path d="M476.794,39.399l-127.09-0.005c-19.411,0-35.203,15.797-35.203,35.214v40.122h-52.404c-0.012,0-0.022-0.001-0.034-0.001 H71.242c-0.022,0-0.044,0.001-0.068,0.001H37.35C16.755,114.73,0,131.486,0,152.08v224.414c0,20.595,16.755,37.35,37.35,37.35 h133.817l-11.799,47.928c-0.01,0.041-0.014,0.083-0.023,0.124c-0.048,0.21-0.086,0.423-0.119,0.639 c-0.016,0.104-0.035,0.207-0.048,0.312c-0.024,0.207-0.035,0.418-0.044,0.632c-0.005,0.107-0.015,0.216-0.016,0.324 c0,0.021-0.003,0.041-0.003,0.061c0,0.261,0.016,0.519,0.038,0.774c0.003,0.033,0.001,0.066,0.005,0.099 c0.031,0.32,0.083,0.636,0.148,0.946c0.008,0.04,0.021,0.078,0.03,0.119c0.061,0.267,0.132,0.53,0.216,0.787 c0.024,0.073,0.054,0.146,0.08,0.219c0.079,0.22,0.164,0.437,0.26,0.649c0.04,0.087,0.083,0.174,0.126,0.26 c0.096,0.193,0.197,0.383,0.305,0.568c0.054,0.091,0.107,0.181,0.164,0.27c0.114,0.179,0.237,0.352,0.364,0.522 c0.043,0.058,0.079,0.121,0.125,0.179c0.02,0.024,0.043,0.047,0.063,0.071c0.154,0.192,0.317,0.374,0.486,0.552 c0.045,0.048,0.086,0.099,0.133,0.146c0.217,0.218,0.444,0.423,0.683,0.616c0.063,0.051,0.129,0.096,0.193,0.146 c0.182,0.14,0.367,0.275,0.559,0.401c0.083,0.054,0.169,0.103,0.254,0.154c0.183,0.111,0.369,0.217,0.562,0.313 c0.089,0.045,0.178,0.087,0.268,0.129c0.197,0.092,0.396,0.175,0.601,0.252c0.09,0.034,0.179,0.068,0.269,0.099 c0.212,0.072,0.428,0.133,0.646,0.189c0.089,0.023,0.175,0.049,0.263,0.068c0.231,0.051,0.465,0.09,0.703,0.121 c0.079,0.01,0.157,0.027,0.238,0.036c0.315,0.034,0.634,0.055,0.957,0.055h105.359h69.171c4.828,0,8.74-3.913,8.74-8.74 c0-4.826-3.912-8.739-8.74-8.739h-58.021l10.161-41.278l152.849-0.005c18.427,0,33.42-14.986,33.42-33.408v-75.6 c17.535-1.994,31.204-16.913,31.204-34.972V74.605C512,55.191,496.206,39.399,476.794,39.399z M359.942,74.605 c0-9.774,7.952-17.726,17.727-17.726h99.125c9.775-0.001,17.727,7.951,17.727,17.726v10.303H359.942V74.605z M359.941,102.385 H494.52v138.593h-4.179l-43.979-48.396c-1.657-1.822-4.006-2.862-6.468-2.862s-4.811,1.039-6.468,2.862l-12.486,13.738 l-31.006-34.107c-1.656-1.821-4.005-2.861-6.467-2.861c-2.461,0-4.81,1.039-6.466,2.862l-17.059,18.768V102.385z M466.723,240.978 h-14.276l-19.695-21.664l7.142-7.859L466.723,240.978z M359.943,216.271l0.347,0.315l23.179-25.501l45.358,49.893h-68.884V216.271 z M331.98,74.609c0-8.911,6.609-16.288,15.175-17.53c-2.978,5.166-4.693,11.147-4.693,17.527V269.86 c0,6.375,1.712,12.355,4.688,17.518c-8.564-1.245-15.171-8.615-15.171-17.518V74.609z M55.301,311.432l70.306-72.26 l93.467,102.804H55.301V311.432z M202.523,297.776l20.999-23.107l61.163,67.305h-41.991v0.001L202.523,297.776z M41.875,396.364 H37.35c-10.957,0.001-19.871-8.913-19.871-19.87V152.08c0-10.957,8.914-19.871,19.871-19.871h4.525 c-2.583,4.74-4.053,10.172-4.053,15.938V380.43C37.822,386.196,39.291,391.625,41.875,396.364z M266.364,455.122h-87.358 l10.161-41.278h87.358L266.364,455.122z M463.317,380.432c0,8.783-7.151,15.929-15.941,15.929H71.242 c-8.79,0-15.941-7.145-15.941-15.929v-20.977h408.016V380.432z M463.317,341.976H308.303l-78.312-86.178 c-1.657-1.822-4.005-2.862-6.468-2.862c-2.462,0-4.811,1.039-6.467,2.862l-26.344,28.987l-58.423-64.245 c-1.622-1.783-3.908-2.818-6.318-2.858c-2.434-0.008-4.731,0.916-6.411,2.644l-64.258,66.043V148.148 c0-8.778,7.133-15.92,15.907-15.938h243.293V269.86c0,19.41,15.792,35.202,35.203,35.202l113.613,0.003V341.976z M494.521,269.859 c0,9.775-7.952,17.727-17.727,17.727l-99.193-0.003c-9.744-0.037-17.66-7.972-17.66-17.724v-11.402h134.579V269.859z"></path>{" "}
              </g>{" "}
            </g>{" "}
          </g>
        </svg>
      ),
    },
    {
      heading: "Website Development",
      description:
        "Our website development services are tailored to bring your digital vision to life. With expertise in front-end and back-end development, we create responsive, scalable, and high-performing websites. From e-commerce platforms to custom web applications, we build robust solutions that empower your online presence and drive business growth.",
      svg: (
        <svg
          fill={isDark ? "#832ac7" : "#4B0D7B"}
          className=" h-16  "
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 399.997 399.997"
          xmlSpace="preserve"
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <g>
              {" "}
              <g>
                {" "}
                <g>
                  {" "}
                  <path d="M366.684,24.971H33.316C14.945,24.971,0,39.917,0,58.288V275.56c0,18.371,14.945,33.317,33.316,33.317h107.412 l-20.387,44.955c-2.105,4.643-1.709,10.037,1.053,14.321c2.762,4.285,7.51,6.873,12.607,6.873h131.996c0.006,0,0.014,0,0.02,0 c8.285,0,15-6.715,15-15c0-2.493-0.605-4.848-1.686-6.916l-20.062-44.233h107.412c18.371,0,33.316-14.946,33.316-33.317V58.288 C400,39.917,385.055,24.971,366.684,24.971z M370,275.561c0,1.829-1.488,3.316-3.316,3.316H33.316 c-1.828,0-3.316-1.487-3.316-3.316V58.288c0-1.829,1.488-3.317,3.316-3.317h333.367c1.828,0,3.316,1.488,3.316,3.317L370,275.561 L370,275.561z"></path>{" "}
                  <path d="M246.198,96.434c-1.057-1.056-2.921-0.9-4.166,0.344l-16.273,16.271c-1.247,1.247-1.4,3.116-0.348,4.171l23.103,23.103 c0.525,0.526,1.261,0.751,2.013,0.688c0.756-0.063,1.53-0.413,2.157-1.038l16.271-16.272c1.244-1.245,1.4-3.111,0.343-4.166 L246.198,96.434z"></path>{" "}
                  <path d="M146.336,197.582c-0.684-0.684-1.748-0.882-2.791-0.523c-1.042,0.359-1.902,1.226-2.257,2.271l-11.118,32.934 c-0.353,1.037-0.148,2.089,0.532,2.768c0.512,0.517,1.24,0.759,2.011,0.693c0.248-0.021,0.503-0.073,0.756-0.16l32.934-11.12 c1.044-0.354,1.912-1.215,2.27-2.256c0.362-1.041,0.162-2.107-0.521-2.792L146.336,197.582z"></path>{" "}
                  <path d="M229.504,182.228c1.451-0.662,2.51-1.965,2.859-3.519c0.35-1.555-0.047-3.185-1.071-4.405 c-1.92-2.283-3.929-4.604-5.997-6.941l18.078-18.077c0.596-0.597,0.972-1.375,1.033-2.157c0.065-0.779-0.185-1.505-0.689-2.01 l-23.104-23.101c-1.056-1.058-2.92-0.903-4.166,0.344l-17.63,17.633c-11.824-11.209-23.699-21.209-34.165-28.732 c-7.369-5.296-20.85-14.199-28.355-14.313c-1.37-0.024-2.695,0.512-3.668,1.479c-0.976,0.966-1.519,2.285-1.508,3.657 c0.039,5.114,4.528,14.341,12.639,25.977c7.72,11.075,18.326,23.802,30.426,36.563l-23,23.002 c-1.248,1.247-1.403,3.111-0.346,4.166l23.103,23.101c0.525,0.531,1.254,0.755,2.011,0.691c0.752-0.063,1.533-0.414,2.155-1.035 l23.446-23.447c2.047,1.811,4.077,3.571,6.079,5.268c0.929,0.787,2.097,1.209,3.296,1.209c0.271,0,0.543-0.022,0.815-0.065 c1.471-0.239,2.765-1.109,3.539-2.383c1.368-2.248,3.15-4.479,5.301-6.626C223.281,185.806,226.284,183.693,229.504,182.228z"></path>{" "}
                  <path d="M242.292,186.495c-5.938,0-11.606,2.531-16.396,7.32c-5.748,5.748-8.257,11.777-7.257,17.438 c0.993,5.604,5.446,10.627,12.22,13.771c5.827,2.707,11.138,3.546,15.821,4.287c4.932,0.778,9.585,1.516,13.726,4.325 c0.857,0.585,1.859,0.882,2.864,0.882c0.706,0,1.415-0.146,2.079-0.444c1.613-0.719,2.74-2.225,2.977-3.977 c1.775-13.241-0.765-25.133-7.152-33.476C256.245,190.186,249.363,186.495,242.292,186.495z"></path>{" "}
                </g>{" "}
              </g>{" "}
            </g>{" "}
          </g>
        </svg>
      ),
    },
    {
      heading: "Graphic Designing",
      description:
        "Our graphic design services are aimed at creating visually compelling and impactful designs that effectively communicate your brand message. From logos and brand identity to marketing collateral and social media graphics, our team of talented designers combines artistic flair with strategic thinking to deliver stunning visuals that capture attention and leave a lasting impression.",
      svg: (
        <svg
          fill={isDark ? "#832ac7" : "#4B0D7B"}
          className=" h-16  "
          viewBox="0 0 1920 1920"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <path
              d="M517.257 1127.343c72.733 0 148.871 36.586 221.274 107.45 87.455 110.418 114.922 204.135 81.632 278.296-72.733 162.274-412.664 234.897-618.666 259.178 34.609-82.62 75.15-216.88 75.15-394.645 0-97.123 66.47-195.455 157.88-233.689 26.698-11.097 54.494-16.59 82.73-16.59Zm229.404-167.109c54.055 28.895 106.462 65.371 155.133 113.494l13.844 15.6c28.016 35.378 50.649 69.987 70.425 104.155-29.554 26.259-59.878 52.737-90.75 79.545-18.898-35.488-43.069-71.964-72.843-109.319l-4.285-4.834c-48.342-47.683-99.43-83.39-151.727-107.011 26.368-30.653 53.066-61.196 80.203-91.63Zm1046.49-803.133c7.801 7.8 18.129 21.754 16.92 52.187-6.043 155.683-284.338 494.405-740.509 909.266-19.995-32.302-41.969-64.822-67.788-97.453l-22.523-25.27c-49.22-48.671-101.408-88.883-156.012-121.074 350.588-385.855 728.203-734.356 910.254-741.828 30.983-.109 44.497 9.01 59.658 24.172Zm126.678 56.472c2.087-53.615-14.832-99.98-56.142-141.29-34.28-34.279-81.962-51.198-134.588-49.11-304.554 12.414-912.232 683.377-1179.54 996.17-53.616-5.383-106.682 2.088-157.441 23.402-132.61 55.263-225.339 193.038-225.339 334.877 0 268.517-103.935 425.737-104.923 427.275L0 1896.747l110.307-6.153c69.217-3.735 681.29-45.375 810.165-332.46 24.39-54.604 29.225-113.163 15.93-175.239 374.32-321.802 972.11-879.71 983.427-1169.322"
              fillRule="evenodd"
            ></path>{" "}
          </g>
        </svg>
      ),
    },
    {
      heading: "Social Marketing",
      description:
        "Our social marketing services are designed to help your brand thrive in the ever-evolving landscape of social media. From creating engaging content and managing social media accounts to implementing targeted advertising campaigns, we leverage the power of social platforms to boost brand awareness, drive audience engagement, and generate meaningful connections with your target audience.",
      svg: (
        <svg
          fill={isDark ? "#832ac7" : "#4B0D7B"}
          className=" h-16  "
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 512 512"
          xmlSpace="preserve"
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <g>
              {" "}
              <g>
                {" "}
                <g>
                  {" "}
                  <path d="M387.027,181.439c1,5.031,5.417,8.512,10.357,8.512c0.683,0,1.378-0.067,2.073-0.205 c5.726-1.14,9.445-6.705,8.307-12.431c-0.251-1.261-0.507-2.518-0.771-3.769c-1.199-5.715-6.805-9.383-12.516-8.177 c-5.714,1.199-9.375,6.802-8.177,12.516C386.548,179.066,386.79,180.25,387.027,181.439z"></path>{" "}
                  <path d="M508.704,460.314l-52.888-52.888c33.613-43.959,51.826-97.429,51.826-153.705c0-67.771-26.391-131.487-74.313-179.408 C385.407,26.391,321.691,0,253.921,0S122.434,26.391,74.512,74.313S0.2,185.95,0.2,253.721 c0,67.581,26.247,131.123,73.913,178.998c0.072,0.078,0.149,0.152,0.223,0.228c0.06,0.06,0.117,0.122,0.177,0.182 c47.922,47.922,111.636,74.313,179.408,74.313c56.083,0,109.38-18.084,153.256-51.476l52.938,52.938 c2.065,2.064,4.77,3.096,7.475,3.096c2.705,0,5.412-1.033,7.475-3.096l33.639-33.638c1.982-1.983,3.096-4.672,3.096-7.475 C511.8,464.987,510.686,462.297,508.704,460.314z M440.622,392.232l-38.393-38.393c7.599-28.059,11.953-58.306,12.758-89.547 h71.271C484.109,312.084,467.456,356.158,440.622,392.232z M407.224,78.977c-9.619,4.27-19.491,8.116-29.593,11.533 c-11.366-21.41-24.679-39.395-39.405-53.547C363.704,46.907,387.01,61.221,407.224,78.977z M169.685,36.935 c-11.294,10.863-21.801,23.991-31.275,39.284c-2.862,4.621-5.595,9.389-8.205,14.29c-10.1-3.417-19.97-7.263-29.589-11.533 C120.849,61.204,144.179,46.881,169.685,36.935z M84.312,94.762c11.85,5.599,24.074,10.57,36.629,14.916 c-17.154,39.249-26.901,85.37-28.102,133.854c-0.888-0.241-1.817-0.382-2.78-0.382H21.594 C24.168,185.898,47.537,133.975,84.312,94.762z M21.594,264.292h68.466c0.964,0,1.892-0.141,2.78-0.382 c1.201,48.485,10.949,94.607,28.103,133.856c-12.555,4.347-24.78,9.317-36.629,14.915 C47.537,373.466,24.168,321.543,21.594,264.292z M100.624,428.47c9.617-4.268,19.489-8.107,29.588-11.526 c2.608,4.897,5.339,9.661,8.198,14.277c9.471,15.288,19.972,28.419,31.263,39.28C144.175,460.557,120.851,446.237,100.624,428.47 z M253.921,486.298c-36.443,0-71.082-23.515-97.537-66.213c-1.905-3.074-3.743-6.228-5.529-9.442 c15.176-4.142,30.803-7.378,46.829-9.652c5.781-0.819,9.802-6.171,8.982-11.952c-0.821-5.781-6.181-9.808-11.952-8.981 c-18.332,2.601-36.19,6.379-53.484,11.301c-17.781-39.719-27.384-87.429-27.384-137.64c0-50.214,9.604-97.928,27.387-137.648 c17.849,5.08,36.297,8.945,55.253,11.551c0.488,0.067,0.974,0.099,1.454,0.099c5.199,0,9.732-3.838,10.46-9.133 c0.795-5.785-3.249-11.118-9.032-11.914c-16.617-2.285-32.807-5.592-48.511-9.878c1.786-3.214,3.625-6.367,5.53-9.443 c26.453-42.696,61.092-66.211,97.536-66.211c39.309,0,76.392,27.405,103.066,75.654c-15.668,4.275-31.821,7.579-48.395,9.862 c-5.784,0.797-9.826,6.132-9.03,11.915c0.796,5.784,6.128,9.821,11.915,9.029c39.889-5.496,77.542-16.538,112.053-32.844 c36.775,39.215,60.143,91.138,62.719,148.389H407.21c-0.448,0-0.888,0.037-1.321,0.091c-0.433-0.054-0.873-0.091-1.321-0.091 c-5.839,0-10.572,4.734-10.572,10.572c0,28.734-3.151,56.644-9.172,82.713l-27.934-27.935 c8.752-16.535,13.399-35.06,13.399-54.299c0-31.063-12.096-60.265-34.06-82.229s-51.167-34.06-82.229-34.06 s-60.265,12.095-82.229,34.06c-21.964,21.964-34.06,51.166-34.06,82.229c0,31.062,12.096,60.264,34.06,82.228 c21.964,21.964,51.167,34.061,82.229,34.061c19.24,0,37.765-4.646,54.3-13.399l50.395,50.395 c-2.311,4.315-4.716,8.527-7.238,12.6C325.002,462.783,290.363,486.298,253.921,486.298z M349.144,254.2 c0,25.413-9.896,49.307-27.867,67.277c-17.97,17.971-41.864,27.868-67.277,27.868c-25.414,0-49.307-9.897-67.278-27.868 c-17.971-17.97-27.867-41.864-27.867-67.277c0-25.414,9.896-49.309,27.867-67.278c17.971-17.971,41.864-27.867,67.278-27.867 s49.307,9.896,67.277,27.867C339.248,204.891,349.144,228.785,349.144,254.2z M338.174,470.494 c11.287-10.859,21.786-23.988,31.255-39.273c1.656-2.671,3.263-5.398,4.834-8.168l17.708,17.708 C375.552,452.913,357.487,462.959,338.174,470.494z M467.589,486.478L326.357,345.244c3.427-2.735,6.726-5.671,9.871-8.817 c3.146-3.146,6.082-6.445,8.817-9.872l141.234,141.234L467.589,486.478z"></path>{" "}
                  <path d="M307.914,243.627h-10.493c-1.102-4.523-2.884-8.782-5.247-12.652l7.425-7.423c4.128-4.128,4.129-10.822,0-14.952 c-4.129-4.126-10.822-4.126-14.951,0l-7.426,7.424c-3.87-2.363-8.13-4.146-12.652-5.248v-10.495 c0-5.838-4.733-10.572-10.572-10.572s-10.572,4.734-10.572,10.572v10.495c-4.523,1.102-8.782,2.885-12.652,5.248l-7.424-7.424 c-4.128-4.127-10.822-4.127-14.951,0c-4.128,4.128-4.128,10.822,0,14.952l7.424,7.423c-2.363,3.87-4.145,8.129-5.247,12.652 h-10.495c-5.839,0-10.572,4.734-10.572,10.572c0,5.838,4.733,10.572,10.572,10.572h10.495c1.102,4.523,2.884,8.782,5.248,12.652 l-7.424,7.424c-4.128,4.128-4.129,10.822,0,14.952c2.065,2.064,4.77,3.096,7.475,3.096c2.705,0,5.412-1.033,7.475-3.096 l7.426-7.424c3.87,2.363,8.129,4.146,12.651,5.248v10.493c0,5.838,4.733,10.572,10.572,10.572s10.572-4.734,10.572-10.572 v-10.493c4.523-1.102,8.782-2.885,12.652-5.248l7.426,7.424c2.065,2.064,4.77,3.096,7.475,3.096s5.412-1.033,7.475-3.096 c4.128-4.128,4.128-10.822,0-14.952l-7.425-7.424c2.363-3.87,4.146-8.129,5.248-12.652h10.493 c5.839,0,10.572-4.734,10.572-10.572C318.488,248.361,313.753,243.627,307.914,243.627z M253.999,277.751 c-12.986,0-23.552-10.565-23.552-23.553c0-12.986,10.565-23.552,23.552-23.552c12.987,0,23.553,10.565,23.553,23.552 C277.551,267.186,266.986,277.751,253.999,277.751z"></path>{" "}
                </g>{" "}
              </g>{" "}
            </g>{" "}
          </g>
        </svg>
      ),
    },
    {
      heading: "SEO/Content Writing",
      description:
        "Our SEO and content writing services are aimed at boosting your online visibility and driving organic traffic to your website. Through comprehensive keyword research, on-page optimization, and strategic content creation, we optimize your website to rank higher in search engine results. ",
      svg: (
        <svg
          fill={isDark ? "#832ac7" : "#4B0D7B"}
          className=" h-16  "
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 392.598 392.598"
          xmlSpace="preserve"
          stroke="#000000"
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <path
              style={{ fill: "#FFFFFF" }}
              d="M21.818,84.234v182.044h53.915c6.012,0,10.925,4.848,10.925,10.925 c0,6.012-4.848,10.925-10.925,10.925H21.818v23.596h26.117c6.012,0,10.925,4.848,10.925,10.925s-4.848,10.925-10.925,10.925H21.818 v26.376c0,6.012,4.848,10.925,10.925,10.925h327.111c6.012,0,10.925-4.848,10.925-10.925V84.234H21.818z"
            ></path>{" "}
            <path
              style={{ fill: "#9884a9" }}
              d="M370.78,32.711c0-6.012-4.848-10.925-10.925-10.925H32.743c-6.012,0-10.925,4.848-10.925,10.925 v51.523H370.78L370.78,32.711L370.78,32.711z"
            ></path>{" "}
            <path
              style={{ fill: "##832ac7" }}
              d="M359.855,0H32.743C14.707,0,0.032,14.675,0.032,32.711v327.111c0,18.101,14.675,32.776,32.711,32.776 h327.111c18.036,0,32.711-14.675,32.711-32.711V32.711C392.566,14.675,377.891,0,359.855,0z M359.855,370.747H32.743 c-6.012,0-10.925-4.848-10.925-10.925v-26.376h26.117c6.012,0,10.925-4.848,10.925-10.925c0-6.012-4.848-10.925-10.925-10.925 H21.818V288h53.915c6.012,0,10.925-4.848,10.925-10.925c0-6.012-4.848-10.925-10.925-10.925H21.818V84.234V32.711 c0-6.012,4.848-10.925,10.925-10.925h327.111c6.012,0,10.925,4.848,10.925,10.925v51.523v275.588 C370.78,365.834,365.867,370.747,359.855,370.747z"
            ></path>{" "}
            <circle
              style={{ fill: "#FFFFFF" }}
              cx="182.141"
              cy="184.501"
              r="59.733"
            ></circle>{" "}
            <path
              style={{ fill: "#56ACE0" }}
              d="M267.475,254.319l-15.515,15.515l48.937,48.937c4.202,4.202,11.442,4.202,15.515,0 c4.331-4.331,4.331-11.313,0-15.515L267.475,254.319z"
            ></path>{" "}
            <g>
              {" "}
              <path
                style={{ fill: "#832ac7" }}
                d="M331.863,287.806l-56.695-56.63c-4.267-4.267-11.119-4.267-15.451,0l-7.822,7.822l-5.236-5.236 c10.408-13.705,16.679-30.707,16.679-49.131c0-44.865-36.396-81.196-81.196-81.196s-81.196,36.331-81.196,81.196 s36.396,81.261,81.196,81.261c18.489,0,35.491-6.271,49.131-16.679l5.236,5.236l-7.822,7.628c-4.267,4.267-4.267,11.119,0,15.451 l56.63,56.63c13.123,13.576,35.168,11.83,46.352,0C344.663,321.422,344.663,300.606,331.863,287.806z M316.477,318.836 c-4.202,4.202-11.442,4.202-15.515,0l-49.002-49.002l15.515-15.515l48.937,48.937C320.679,307.523,320.679,314.505,316.477,318.836 z M122.408,184.501c0-32.97,26.764-59.733,59.733-59.733s59.733,26.764,59.733,59.733s-26.764,59.733-59.733,59.733 S122.408,217.535,122.408,184.501z"
              ></path>{" "}
              <path
                style={{ fill: "#832ac7" }}
                d="M248.663,49.325c0-6.012-4.848-10.925-10.925-10.925H48c-6.012-0.065-10.925,4.848-10.925,10.925 S41.923,60.25,48,60.25h189.802C243.814,60.186,248.663,55.337,248.663,49.325z"
              ></path>{" "}
              <path
                style={{ fill: "#832ac7" }}
                d="M279.24,60.186h10.925c6.012,0,10.925-4.848,10.925-10.925s-4.848-10.925-10.925-10.925H279.24 c-6.012,0-10.925,4.848-10.925,10.925S273.164,60.186,279.24,60.186z"
              ></path>{" "}
              <path
                style={{ fill: "#832ac7" }}
                d="M344.598,38.335h-10.925c-6.012,0-10.925,4.848-10.925,10.925s4.848,10.925,10.925,10.925h10.925 c6.012,0,10.925-4.848,10.925-10.925S350.61,38.335,344.598,38.335z"
              ></path>{" "}
              <path
                style={{ fill: "#832ac7" }}
                d="M151.887,154.246c-4.267,4.267-4.267,11.119,0,15.451c4.267,4.267,11.119,4.267,15.451,0 c8.21-8.21,21.527-8.21,29.802,0c4.202,4.331,11.119,4.073,15.451,0c4.267-4.267,4.267-11.119,0-15.451 C195.782,137.438,168.566,137.438,151.887,154.246z"
              ></path>{" "}
            </g>{" "}
          </g>
        </svg>
      ),
    },
    {
      heading: "GMB Presence",
      description:
        "We specialize in optimizing your Google My Business (GMB) presence to enhance your local online visibility. By leveraging GMB’s features, including accurate business information, customer reviews, and posts, we ensure that your business stands out in local search results. Our strategies focus on maximizing your GMB presence to attract more local customers, increase foot traffic, and improve your overall online reputation.",
      svg: (
        <svg
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
          stroke={isDark ? "#000000" : "#DADADA"}
          fill={isDark ? "#832ac7" : "#4B0D7B"}
          className="cf-icon-svg h-16  "
        >
          <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            strokeLinecap="round"
            strokeLinejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            {" "}
            <defs>
              {" "}
              <style>
                .cls-1fill:#dbe9fa;.cls-2fill:#d9dce1;.cls-3fill:#ffffff;.cls-4fill:#52acf9;
              </style>{" "}
            </defs>{" "}
            <g data-name=" performance" id="_performance">
              {" "}
              <circle className="cls-1" cx="16" cy="16" r="16"></circle>{" "}
              <rect className="cls-2" height="14" width="6" x="2" y="16"></rect>{" "}
              <rect
                className="cls-3"
                height="19"
                width="6"
                x="11"
                y="11"
              ></rect>{" "}
              <polygon
                className="cls-4"
                points="23 1.4 16.92 9 20 9 20 30 26 30 26 9 29.08 9 23 1.4"
              ></polygon>{" "}
              <path d="M2,30H8V16H2ZM4,18H6V28H4Zm7,12h6V11H11Zm2-17h2V28H13ZM23,1.4,16.92,9H20V30h6V9h3.08ZM24,7V28H22V7h-.92L23,4.6,24.92,7Z"></path>{" "}
            </g>{" "}
          </g>
        </svg>
      ),
    },
  ];

  return (
    <div
      className={`main-offer-page pt-8 ${isDark ? "text-white" : "text-black"}`}
    >
      <div className="intro-offer">
        <p className="our-services text-center text-[10px] py-2">
          OUR SERVICE LIST
        </p>
        <p className="offer-heading text-center text-[25px] md:text-[35px] font-bold ">
          What We Offer To You !
        </p>
      </div>

      <div
        className="gradient-line my-3"
        style={{
          width: "70%",
          borderRadius:"100%",
          margin: "20px auto",
          height: "4px",
          background: `linear-gradient(to right,  ${
            isDark ? "black" : "#dadada"
          }, #560C8E, ${isDark ? "black" : "#dadada"})`,

          boxShadow: "rgba(105, 10, 176, 0.7) 0px 0px 15px",
        }}
      />

      <div className="offer-cards lg:w-[85%]  w-full px-3  mx-auto my-12 flex flex-wrap justify-center items-center">
        {offercardoptions.map((o, idx) => (
          <OfferCard
            key={idx}
            heading={o.heading}
            description={o.description}
            svg={o.svg}
            idx={idx}
          />
        ))}
      </div>

      <div
        className="gradient-line my-3"
        style={{
          width: "60%",
          borderRadius:"100%",
          margin: "55px auto 55px auto", //T R B L
          height: "4px",
          background: `linear-gradient(to right,  ${
            isDark ? "#300051" : "#dadada"
          }, #9903E0, ${isDark ? "#300051" : "#dadada"})`,

          // boxShadow: "rgba(105, 10, 176, 0.7) 0px 0px 15px",
        }}
      />
    </div>
  );
}

export default Offerpage;
